<div *ngIf="data" layout="row" [ngClass]="styles.kpiWrapper">
	<vb-ui-report-cell flex="1 1 0" [header]="'Media_Videos_Views' | translate" [headerTag]="'h2'">
		<vb-ui-kpi [value]="data.totalVideoViews" [hideChangeIndicators]="true">
		</vb-ui-kpi>
	</vb-ui-report-cell>

	<vb-ui-report-cell flex="1 1 0" [header]="'Reports_UniqueViewers' | translate" [headerTag]="'h2'">
		<vb-ui-kpi [value]="data.uniqueViewers" [hideChangeIndicators]="true">
		</vb-ui-kpi>
	</vb-ui-report-cell>

	<vb-ui-report-cell flex="1 1 0" [header]="'Reports_AverageViewingTime' | translate" [headerTag]="'h2'">
		<span [ngClass]="styles.kpiData">
			{{ (data.avgViewingDurationSecs * 1000) | vbTimespan:true:true }}
		</span>
	</vb-ui-report-cell>

	<vb-ui-report-cell flex="1 1 0" [header]="'Reports_CompletionRate' | translate" [headerTag]="'h2'">
		<vb-ui-kpi [value]="data.completionRate" [hideChangeIndicators]="true" [suffix]="'%'">
		</vb-ui-kpi>
	</vb-ui-report-cell>
</div>
